<template>
  <panel>
    <h3>{{ resultMessage }}</h3>

    <w-button class="btn-primary float-right" text="Powrót do dokumentu" @click="goToDocumentDetails" />
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import { config } from '@/utils/config';

// @vuese
// Rezultat podpisania wniosku
// @group epuap
export default {
  components: { Panel },
  props: {
    success: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    resultMessage() {
      return this.success ? 'Wniosek został podpisany.' : 'Nie udało się podpisać wniosku.';
    }
  },
  methods: {
    // @vuese
    // Przechodzi do szczegółów dokumentu
    goToDocumentDetails() {
      this.$router.push({ name: 'documentDetails' });
    }
  }
};
</script>
